import Button from "components/Button/index";
import React from "react";

import DrawerRTL from "components/DrawerRTL/index";
import useScreenMobile from "hooks/useScreen";
import Drawer from "components/Drawer/index";
import "./planSummary.scss";

const PlanSummary = ({
  isPayNowOpen,
  handleCancel,
  price,
  setSuccessState,
  initiatePayment
  // successState
}) => {
  const isMobile = useScreenMobile({ size: 992 });
  const handlePayment = async () => {
    
    if (initiatePayment) {
      await initiatePayment();
    }

    setSuccessState(true);
  };

  return isMobile ? (
    <Drawer
      showCross={true}
      heading="Payment Summary "
      showFooter={false}
      isVisible={isPayNowOpen}
      handleCancel={handleCancel}
    >
      <div className="paymentSummary">
        <h5 className="paymentSummaryText">
          Please complete the payment to unlock all features in your Induz
          account.
        </h5>

        <div className="paymentDetails">
          <div className="paymentHeading">
            <h5 className="paymentType">Professional Plan</h5>
            <p className="paymentAmount">$ {price}</p>
          </div>
          <div className="paymentHeading">
            <h5 className="paymentType">Tax/GST</h5>
            <p className="paymentAmount">$5</p>
          </div>
          <div className="paymentSummaryData">
            <h5 className="paymentTotal">Total</h5>
            <p className="paymentTotal">$ {price + 5}</p>
          </div>
        </div>

        <div className="buttonContainer">
          <Button onClick={handlePayment} title="Pay Now" type="violet" />
        </div>
      </div>
    </Drawer>
  ) : (
    <DrawerRTL
      heading="Payment Summary "
      showFooter={false}
      isVisible={isPayNowOpen}
      handleCancel={handleCancel}
    >
      <div className="paymentSummary">
        <h5 className="paymentSummaryText">
          Please complete the payment to unlock all features in your Induz
          account.
        </h5>

        <div className="paymentDetails">
          <div className="paymentHeading">
            <h5 className="paymentType">Professional Plan</h5>
            <p className="paymentAmount">$ {price}</p>
          </div>
          <div className="paymentHeading">
            <h5 className="paymentType">Tax/GST</h5>
            <p className="paymentAmount">$5</p>
          </div>
          <div className="paymentSummaryData">
            <h5 className="paymentTotal">Total</h5>
            <p className="paymentTotal">$ {price + 5}</p>
          </div>
        </div>

        <div className="buttonContainer">
          <Button title="Cancel" type="white" onClick={handleCancel} />
          <Button title="Pay Now" type="violet" onClick={handlePayment} />
        </div>
      </div>
    </DrawerRTL>
  );
};

export default PlanSummary;
